<template>
  <section>
    <div :class="['be-loading', { 'be-loading-active': isBusy }]">
      <div class="table-responsive">
        <table
          class="table p-0 m-0 dataTable text-nowrap"
          :class="accountPosting.length > 1 ? 'min-h-[200px]' : 'min-h-[300px]'"
        >
          <thead class="bg-white">
            <tr>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                PaymentID
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Customer Name
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                AccountID
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Amount (₦)
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Payment Date
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Authorized By
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Status
              </th>
              <th
                class="text-[12px] leading-[18px] text-[#000000] font-semibold"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-if="loading">
              <td colspan="12" class="text-center">
                <div
                  class="text-center"
                  style="padding-top: 100px; padding-bottom: 50px"
                >
                  <span
                    class="fa-solid fa-spinner fa-spin text-[#2463EB]"
                    style="font-size: 8rem"
                  ></span>
                  <h3
                    class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                    style="padding-bottom: 100px"
                  >
                    Please wait while we load the list
                  </h3>
                </div>
              </td>
            </tr>
            <tr v-for="a in accountPosting" :key="a.id" v-else>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ a.paymentId }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ a.owner ? a.owner.displayName : "---" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ a.owner && a.owner.code ? a.owner.code : "---" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ a.paidAmount }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ formatDate(a.created) }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                {{ a.authorizedBy ? a.authorizedBy.displayName : "---" }}
              </td>
              <td
                class="text-[14px] font-normal leading-[16.94px] text-[#353535]"
              >
                <span
                  class="flex items-center gap-[4px] max-w-max w-full"
                  :class="[
                    'badge',
                    {
                      'badge-success': a.paymentStatus == 'AUTHORIZED',
                      'badge-warning':
                        a.paymentStatus == 'PENDING AUTHORIZATION',
                      'badge-danger': a.paymentStatus == 'REVERSED',
                    },
                  ]"
                >
                  <span
                    class="w-[10px] h-[10px] rounded-[1px]"
                    :style="{
                      backgroundColor:
                        a.paymentStatus == 'AUTHORIZED'
                          ? '#16a249'
                          : a.paymentStatus == 'REVERSED'
                          ? '#DC2828'
                          : ' #fbbc05',
                    }"
                  ></span>
                  <span class="text-[12px] font-normal leading-[16.94px]">
                    {{
                      a.paymentStatus == "AUTHORIZED"
                        ? "Authorized"
                        : a.paymentStatus == "REVERSED"
                        ? "Reversed"
                        : "Pending"
                    }}
                  </span>
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn-no-border"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span
                      class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none"
                      >...</span
                    >
                  </button>
                  <ul
                    class="dropdown-menu shadow-none"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      @click="viewPosting(a)"
                    >
                      View
                    </li>
                    <li
                      v-if="a.paymentStatus == 'PENDING AUTHORIZATION'"
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      @click="viewAuthorize(a.id, a.paymentId)"
                    >
                      Authorize
                    </li>
                    <li
                      v-if="
                        a.paymentStatus !== 'REVERSED' &&
                          a.paymentStatus !== 'PENDING AUTHORIZATION'
                      "
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      @click="attemptReverse(a.id)"
                    >
                      Reverse Authorization
                    </li>
                    <li
                      v-if="a.paymentStatus != 'REVERSED'"
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px] border-b"
                      @click="initiatePrintReceipt(a.id)"
                    >
                      Print Receipt
                    </li>
                    <li
                      v-if="hasPermission('View_Customer_Account')"
                      class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[10px] px-[16px]"
                      @click="ViewCustomerAccount(a.owner.id)"
                    >
                      View Customer Account
                    </li>
                    <!-- <li
                      class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[10px] px-[16px]"
                    >
                      Delete
                    </li> -->
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="!accountPosting.length && !loading">
              <td colspan="12">
                <div class="text-center" style="padding-top: 50px">
                  <span
                    style="font-size: 4.615rem"
                    class="fa-solid fa-truck text-[#2463EB]"
                  ></span>
                </div>
                <h3
                  class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                  style="padding-bottom: 100px"
                >
                  You don't have any posting.
                </h3>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal fade py-1" id="mod-authorize" role="dialog">
        <div class="modal-dialog max-w-[500px] mx-auto w-full relative">
          <div class="modal-content p-[10px] md:p-[20px] bg-[#f8f8f8]">
            <button
              class="absolute right-6 top-4 text-2xl outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
            <div class="text-center">
              <div class="flex justify-center items-center my-[16px]">
                <img src="/assets/img/tick-circle.png" alt="" />
              </div>

              <p
                class="text-[18px] leading-[28px] font-semibold text-[#353535] mb-[4px] md:mx-2"
              >
                Posted Successfully
              </p>
              <p class="text-[14px] font-normal text-[#96a0b5] md:mx-2">
                Are you sure you want authorize Payment
                <span class="font-semibold">{{ selectedPaymentId }}</span>
              </p>
              <div class="flex items-center justify-center gap-[8px] mt-[16px]">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-hidden="true"
                  class="border border-solid border-[#96a0b5] rounded-[8px] text-[#96a0b5] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
                >
                  Close
                </button>
                <button
                  @click="confirmAuthorize"
                  type="button"
                  class="border-[1px] bg-[#2463eb] rounded-[8px] text-white border-solid px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
                >
                  Yes, Authorize
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade py-1" id="mod-authorize-success" role="dialog">
        <div class="modal-dialog max-w-[500px] mx-auto w-full relative">
          <div class="modal-content p-[10px] md:p-[20px] bg-[#f8f8f8]">
            <button
              class="absolute right-6 top-4 text-2xl outline-none focus:outline-none"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
            <div class="text-center">
              <div class="flex justify-center items-center my-[16px]">
                <img src="/assets/img/tick-circle.png" alt="" />
              </div>

              <p
                class="text-[18px] leading-[28px] font-semibold text-[#353535] mb-[4px] md:mx-2"
              >
                Payment Successfully Authorized
              </p>
              <p class="text-[14px] font-normal text-[#96a0b5] md:mx-2">
                Your have successfully authorized this payment. This action can
                be reversed if it wasn't performed by you
              </p>
              <div class="w-full mt-[16px]">
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-hidden="true"
                  class="border border-solid border-[#96a0b5] rounded-[8px] text-[#96a0b5] px-[16px] sm:px-[24px] text-[14px] md:text-[16px] py-[16px] w-full outline-none focus:outline-none"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import { bus } from "../../main";
export default {
  props: [
    "accountPosting",
    "hasPermission",
    "loading",
    "viewPosting",
    "authorize",
    "attemptReverse",
    "initiatePrintReceipt",
  ],
  data() {
    return {
      selectedId: null,
      selectedPaymentId: null,
      isBusy: false,
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },
    viewAuthorize(id, paymentId) {
      this.selectedId = id;
      this.selectedPaymentId = paymentId;
      $("#mod-authorize").modal("show");
    },
    confirmAuthorize() {
      if (this.selectedId) {
        this.authorize(this.selectedId);
        $("#mod-authorize").modal("hide");
      }
    },
    ViewCustomerAccount(ownerId) {
      this.$router.push({ path: "/customers" }).then(() => {
        bus.$emit("openCustomerModal", ownerId);
      });
    },
  },
};
</script>
